    <div class="right-panel d-flex h-100">
      <p id="emptyJobsError" *ngIf="available === false">No Jobs Available .</p>
      <div class="right-side w-100">
        <as-split direction="horizontal">
          <as-split-area
            [size]="jobViewOpen ? (advancedViewLength == 80 ? 20 : 0) : 100"
          >
            <div class="jobList w-100 h-100">
              <div class="actionBar">
                <div class="flex-grow-1 h-100">
                  <input
                    class="search float-start"
                    type="text"
                    placeholder="Search by Name or Tag"
                    [(ngModel)]="filterText"
                    (ngModelChange)="onSearch()"
                  />
                </div>

            <!-- <a *ngIf="JupyterHubUrl" [href]="JupyterHubUrl" target="_blank" rel="noopener" class="mx-2" ngbTooltip="JupyterHub" placement="top auto" container="body" triggers="hover">
              <img src="assets/images/syncious/Jupyter_logo.svg" alt="JupyterHub Logo" class="p-0 zoom-hover"
                   style="height: 30px;">
            </a> -->

            <button
              type="button"
              class="actionBtn"
              (click)="refreshComponent()"
              placement="top auto"
              container="body"
              triggers="hover"
              ngbTooltip="Refresh Jobs"
            >
              <span class="bi bi-arrow-clockwise"></span>
            </button>

            @if(!jobViewOpen) {
            <!-- <button type="button" class="actionBtn" (click)="toggleFilters()" placement="top auto" container="body"
    triggers="hover" ngbTooltip="Show/Hide Filters">
    <span class="bi bi-funnel"></span>
  </button> -->

            <div class="position-relative" *ngIf="selectedJobIds.length > 1">
              <button
                type="button"
                class="actionBtn"
                id="CollectiveOptions"
                [ngbPopover]="popContent"
                popoverClass="CollectiveOptionPopover"
                popoverPlacement="bottom"
                [container]="'body'"
                [autoClose]="true"
                triggers="click"
                (mouseenter)="tooltipInstance.open()"
                (mouseleave)="tooltipInstance.close()"
                #tooltipInstance="ngbTooltip"
                [ngbTooltip]="'Actions for selected jobs'"
                tooltipPlacement="bottom"
                tooltipClass="action-tooltip"
                #p="ngbPopover"
              >
                <i class="bi bi-check2-circle"></i>
              </button>
            </div>

            <ng-template #popContent>
              <div class="popover-actions">
                <button
                  class="btn dropdown-item"
                  style="padding: 5px 10px !important"
                  (click)="collectiveOptionsAction('Delete')"
                  id="DeleteSelectedJobsButton"
                >
                  Delete Jobs
                </button>
                <button
                  class="btn dropdown-item"
                  style="padding: 5px 10px !important"
                  (click)="collectiveOptionsAction('Cancel')"
                  id="CancelSelectedJobsButton"
                >
                  Cancel Jobs
                </button>
                <button
                  class="btn dropdown-item"
                  style="padding: 5px 10px !important"
                  (click)="collectiveOptionsAction('ForceInactive')"
                  id="ForceInactiveselectedJobsButton"
                >
                  Force Inactive
                </button>
              </div>
            </ng-template>

            <button
              type="button"
              class="actionBtn"
              [ngbPopover]="filterContent"
              #filterPopover="ngbPopover"
              [autoClose]="'outside'"
              popoverClass="filter-popover"
              container="body"
              placement="top auto"
              (mouseenter)="tooltipInstance.open()"
              (mouseleave)="tooltipInstance.close()"
              [ngbTooltip]="'Show/Hide Filters'"
              #tooltipInstance="ngbTooltip"
              [disabled]="selectedJobIds.length > 1"
              [class.disabledButton]="selectedJobIds.length > 1"
            >
              <span class="bi bi-funnel"></span>
              <span
                class="position-absolute top-0 start-100 badge rounded-pill"
                *ngIf="getActiveFiltersCount() > 0"
              >
                {{ getActiveFiltersCount() }}
                <span class="visually-hidden">unread messages</span>
              </span>
            </button>

            <!---button for repo download-->
            <!-- <button type="button"
                    class="actionBtn"
                    [ngbPopover]="downloadRepo"
                    #x="ngbPopover"
                    [autoClose]="'outside'"
                    popoverClass="filter-popover"
                    container="body"
                    placement="top auto"
                    (mouseenter)="tooltipInstance.open()"
                    (mouseleave)="tooltipInstance.close()"
                    [ngbTooltip]="'download repo'"
                    #tooltipInstance="ngbTooltip">
              <span class="bi bi-funnel"></span>
            </button> -->

            <button
              class="actionBtn"
              style="margin-left: 5px"
              (click)="editColoum()"
              placement="top auto"
              container="body"
              triggers="hover"
              ngbTooltip="Add/Remove columns from table"
              [disabled]="selectedJobIds.length > 1"
              [class.disabledButton]="selectedJobIds.length > 1"
            >
              <span><i class="bi bi-sliders"></i></span>
            </button>

            <button
              class="actionBtn"
              style="margin-left: 2px"
              (click)="editQuery()"
              placement="top auto"
              container="body"
              triggers="hover"
              ngbTooltip="Run query based filter"
              [disabled]="selectedJobIds.length > 1"
              [class.disabledButton]="selectedJobIds.length > 1"
            >
              <span><i class="bi bi-database-gear"></i></span>
            </button>

            <button
              *ngIf="isMonitor == false"
              type="button"
              class="actionBtn"
              (click)="runCommand()"
              placement="top auto"
              container="body"
              triggers="hover"
              ngbTooltip="Run command on HeadNode"
              [disabled]="selectedJobIds.length > 1"
              [class.disabledButton]="selectedJobIds.length > 1"
            >
              <span class="bi bi-code-slash"></span>
              <span class="button-animation">Run Command</span>
            </button>

            <button
              type="button"
              class="actionBtn"
              (click)="reorderQueuedJobs()"
              placement="top auto"
              container="body"
              triggers="hover"
              ngbTooltip="Reorder execute-queued jobs"
              [disabled]="selectedJobIds.length > 1"
              [class.disabledButton]="selectedJobIds.length > 1"
            >
              <span class="bi bi-shuffle"></span>
              <span class="button-animation">Reorder Jobs</span>
            </button>

            <button
              *ngIf="isMonitor == false && isGlobalAdmin"
              (click)="importJobs()"
              type="button"
              class="actionBtn"
              placement="top auto"
              triggers="hover"
              ngbTooltip="Import Jobs"
              [disabled]="selectedJobIds.length > 1"
              [class.disabledButton]="selectedJobIds.length > 1"
            >
              <span class="bi bi-file-earmark-arrow-up"></span>
            </button>
            }

            <button
              *ngIf="isMonitor == false"
              type="button"
              class="actionBtn button-hover position-relative"
              placement="top auto"
              container="body"
              triggers="hover"
              ngbTooltip="Create new job"
              [matMenuTriggerFor]="jobWizardType"
              #menuTrigger="matMenuTrigger"
              [disabled]="selectedJobIds.length > 1"
              [class.disabledButton]="selectedJobIds.length > 1"
            >
              <span class="bi bi-briefcase"></span>
              <span class="bi bi-plus-circle-fill overlay-icon-plus"></span>
            </button>

            <mat-menu #jobWizardType="matMenu" class="addJobMenu overflow-auto">
              <button
                type="button"
                mat-menu-item
                (click)="openDialog('Command')"
              >
                Command
              </button>
              <!-- <button type="button" mat-menu-item (click)="openDialog('AIML')">
      AIML
    </button> -->
              <button
                type="button"
                *ngFor="let app of nestedAppNames"
                mat-menu-item
                (click)="openDialog(app.appName)"
                [matMenuTriggerFor]="nestedMenu"
              >
                {{ app.appName }}
                <mat-menu #nestedMenu="matMenu">
                  <ng-container
                    *ngIf="app.templates && app.templates.split(',').length > 0"
                  >
                    <button
                      type="button"
                      mat-menu-item
                      (click)="openDialog(app.appName)"
                    >
                      New Job
                    </button>
                    <ng-container
                      *ngFor="let template of app.templates.split(',')"
                    >
                      <button
                        type="button"
                        *ngIf="template.trim()"
                        mat-menu-item
                        (click)="
                          openDialog(app.appName, template.trim(), '', true)
                        "
                      >
                        {{ template.trim() }}
                      </button>
                    </ng-container>
                  </ng-container>
                </mat-menu>
              </button>
              <button
                type="button"
                *ngFor="let app of nonNestedAppNames"
                mat-menu-item
                (click)="openDialog(app.appName)"
              >
                {{ app.appName }}
              </button>
            </mat-menu>
          </div>
          <ng-container *ngIf="toShowFilter">
            <div class="actionBar">
              <div
                ngDefaultControl
                style="
                  margin-right: 4px;
                  color: var(--s-primary-color);
                  font-size: 0.9rem;
                "
              >
                From {{ startRange }} To
              </div>
              <ng-select
                name="showEntries"
                class="searchFilter w-6"
                [clearable]="false"
                [searchable]="false"
                id=""
                [(ngModel)]="entries"
                ngDefaultControl
                (ngModelChange)="loadJobDataForRange(entries)"
              >
                <ng-option
                  *ngFor="let entries of jobEntries; let i = index"
                  [value]="entries"
                >
                  {{ entries }}
                </ng-option>
              </ng-select>
              <ng-select name="status"
                         class="searchFilter"
                         id=""
                         [(ngModel)]="filterUser"
                         (ngModelChange)="applyFilter()"
                         [clearable]="false">
                <ng-option value="All"
                           *ngIf="isGlobalAdmin || isReader"
                           [selected]="onLoadAllJobsSelection && filterUser == 'All'">
                  All Jobs
                </ng-option>
                <ng-option value="{{ currentUser }}"
                           [selected]="!onLoadAllJobsSelection || filterUser == currentUser">
                  My Jobs
                </ng-option>
                <ng-option *ngFor="let jobUser of jobUsers"
                           value="{{ jobUser }}">
                  {{ jobUser }} Jobs
                </ng-option>
              </ng-select>
              <ng-select
                [items]="statuses"
                bindLabel="name"
                bindValue="id"
                class="custom-select"
                [multiple]="true"
                [(ngModel)]="selectedStatuses"
                (ngModelChange)="applyFilter()"
                [closeOnSelect]="false"
                [placeholder]="'All Status'"
                [searchable]="false"
              >
                <ng-template ng-option-tmp let-item="item" let-item$="item$">
                  <input type="checkbox" [checked]="item$.selected" />
                  {{ item.name }}
                </ng-template>
                <ng-template
                  ng-multi-label-tmp
                  let-items="items"
                  let-clear="clear"
                >
                  <div
                    class="ng-value"
                    style="margin-top: 0px"
                    *ngIf="items.length > 0"
                  >
                    <span class="ng-value-label">{{ items[0].name }}</span>
                    <span *ngIf="items.length > 1" class="ng-value-label">
                      +{{ items.length - 1 }}
                    </span>
                  </div>
                </ng-template> </ng-select
              >&nbsp;
              <ng-select
                name="status"
                class="searchFilter"
                id=""
                [(ngModel)]="filterCores"
                (ngModelChange)="applyFilter()"
                [clearable]="false"
                [searchable]="false"
              >
                <ng-option value="All" [selected]="filterCores == 'All'">
                  All Cores
                </ng-option>
                <ng-option *ngFor="let n of coresList" value="{{ n }}">
                  {{ n }}
                </ng-option>
              </ng-select>
              <ng-select
                name="status"
                class="searchFilter"
                id=""
                [(ngModel)]="filterApplication"
                (ngModelChange)="applyFilter()"
                [clearable]="false"
              >
                <ng-option value="All" [selected]="filterApplication == 'All'">
                  All Application
                </ng-option>
                <ng-option value="Command">Command</ng-option>
                <ng-option *ngFor="let app of uniqueAppNames" value="{{ app }}">
                  {{ app }}
                </ng-option>
              </ng-select>
              <ng-select
                name="nodes"
                class="searchFilter"
                id=""
                [(ngModel)]="filterNodes"
                (ngModelChange)="applyFilter()"
                [clearable]="false"
                [searchable]="false"
              >
                <ng-option value="All" [selected]="filterNodes == 'All'">
                  All Nodes
                </ng-option>
                <ng-option *ngFor="let n of nodeList" value="{{ n }}">
                  {{ n }}
                </ng-option>
              </ng-select>
              <ng-select
                name="nodegroups"
                class="searchFilter"
                id=""
                [(ngModel)]="filterNodeGroup"
                (ngModelChange)="applyFilter()"
                [clearable]="false"
                [searchable]="false"
              >
                <ng-option value="All" [selected]="filterNodeGroup == 'All'">
                  All Node Groups
                </ng-option>
                <ng-option *ngFor="let n of nodeGroupsList" value="{{ n }}">
                  {{ n }}
                </ng-option>
              </ng-select>
              <input
                [max]="todayDate"
                [owlDateTimeTrigger]="dt8"
                [owlDateTime]="dt8"
                [selectMode]="'range'"
                [formControl]="dateTimePeriod"
                class="me-2 inputbar searchFilter search"
                placeholder="Choose period"
                readonly
              />
              <owl-date-time [pickerType]="'calendar'" #dt8></owl-date-time>
              <button
                type="button"
                class="actionBtn"
                title="Reset applied filters"
                (click)="resetFilter()"
                placement="top auto"
                container="body"
                triggers="hover"
                ngbTooltip="Reset applied filters"
                #btnResetFilter
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="currentColor"
                >
                  <path
                    d="M520-330v-60h160v60H520Zm60 210v-50h-60v-60h60v-50h60v160h-60Zm100-50v-60h160v60H680Zm40-110v-160h60v50h60v60h-60v50h-60Zm111-280h-83q-26-88-99-144t-169-56q-117 0-198.5 81.5T200-480q0 72 32.5 132t87.5 98v-110h80v240H160v-80h94q-62-50-98-122.5T120-480q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-840q129 0 226.5 79.5T831-560Z"
                  />
                </svg>
              </button>
            </div>
          </ng-container>
          <div class="listTable">
            <div class="jobs flex-grow-1">
              <table
                class="table table-hover table-condensed"
                [ngClass]="{ 'minW-90': jobViewOpen }"
                cellspacing="0"
                id="jobInfoListID"
                style="border-collapse: collapse"
                dynamicPagination
                [rowHeight]="32"
                [offsetHeight]="200"
                [paginationInstance]="config"
              >
                <thead>
                  <tr class="jobHeadRow table-list-head" #jobHeadRow>
                    <th>
                      <input type="checkbox"
                             class="checkbox selectAll"
                             name="Select All Jobs"
                             id=""
                             [checked]="checkIfAllSelected()"
                             (change)="wholePageJobs($event)" />
                    </th>
                    <th resizable scope="col">
                      ID
                      <span style="cursor: pointer"
                            (click)="sortSrNo()"
                            title="Sort Ascending/Descending"
                            [ngClass]="
                          serialNoSort
                            ? 'bi-arrow-up-short'
                            : 'bi-arrow-down-short'
                        "
                            class="bi"></span>
                    </th>
                    <th resizable scope="col" #jobNameHead>
                      Job Name
                      <span style="cursor: pointer"
                            (click)="sortJobs()"
                            title="Sort Alphabetically"
                            [ngClass]="
                          jobSort ? 'bi-arrow-up-short' : 'bi-arrow-down-short'
                        "
                            class="bi"></span>
                    </th>
                    <th resizable
                        scope="col"
                        *ngIf="editedColumnList.includes('Global State')">
                      Global State
                    </th>
                    <th resizable
                        scope="col"
                        *ngIf="editedColumnList.includes('Stage')">
                      Stage
                    </th>
                    <th resizable
                        scope="col"
                        *ngIf="editedColumnList.includes('Status')">
                      Status
                    </th>
                    <th resizable
                        scope="col"
                        *ngIf="editedColumnList.includes('Application')">
                      Application
                    </th>
                    <th resizable
                        scope="col"
                        *ngIf="editedColumnList.includes('Version')">
                      Version
                    </th>
                    <th resizable
                        scope="col"
                        *ngIf="editedColumnList.includes('User')">
                      User
                      <span style="cursor: pointer"
                            (click)="sortUsers()"
                            title="Sort Alphabetically"
                            [ngClass]="
                          userSort ? 'bi-arrow-up-short' : 'bi-arrow-down-short'
                        "
                            class="bi"></span>
                    </th>
                    <th resizable
                        scope="col"
                        *ngIf="editedColumnList.includes('#Cores')">
                      #Cores
                      <span style="cursor: pointer"
                            (click)="sortCores()"
                            title="Sort Ascending/Descending"
                            [ngClass]="
                          coresSort
                            ? 'bi-arrow-up-short'
                            : 'bi-arrow-down-short'
                        "
                            class="bi"></span>
                    </th>
                    <th resizable
                        *ngIf="editedColumnList.includes('BatchNode')"
                        scope="col">
                      BatchNode
                    </th>
                    <th resizable
                        *ngIf="editedColumnList.includes('Node Group')"
                        scope="col">
                      Node Group
                    </th>
                    <th resizable
                        *ngIf="editedColumnList.includes('UserGroup')"
                        scope="col">
                      UserGroup
                    </th>
                    <th resizable
                        *ngIf="editedColumnList.includes('Create Time')"
                        scope="col">
                      Create Time
                      <span (click)="sortByCreateTime()"
                            title="Sort Ascending/Descending"
                            [ngClass]="
                          timeCreateSort
                            ? 'bi-arrow-up-short'
                            : 'bi-arrow-down-short'
                        "
                            class="bi"></span>
                    </th>
                    <th resizable
                        *ngIf="editedColumnList.includes('End Time')"
                        scope="col">
                      End Time
                      <span (click)="sortByEndTime()"
                            title="Sort Ascending/Descending"
                            [ngClass]="
                          timeSort ? 'bi-arrow-up-short' : 'bi-arrow-down-short'
                        "
                            class="bi"></span>
                    </th>
                    <th resizable
                        *ngIf="editedColumnList.includes('Run Time')"
                        scope="col">
                      Run Time
                      <span (click)="sortByRunTime()"
                            title="Sort Ascending/Descending"
                            [ngClass]="
      timeSort ? 'bi-arrow-up-short' : 'bi-arrow-down-short'
    "
                            class="bi"></span>
                    </th>
                    <th resizable
                        scope="col"
                        *ngIf="editedColumnList.includes('Tag')">
                      Tag
                    </th>
                    <th resizable scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  @for (job of jobs | paginate: { itemsPerPage:
                  config.itemsPerPage, currentPage: config.currentPage, id:
                  'job_pagination' }; let i = $index; track trackJob(job, i)) {
                  <tr class="jobRow table-list-row"
                      (click)="redirectTo(job)"
                      (dblclick)="toggleJobView(job)"
                      ng-db
                      [ngClass]="{
                      highlightClickedRow: highlightClickedJob == job.number
                    }">
                    <td>
                      <input type="checkbox"
                             class="checkbox multiJobSelect"
                             name="{{ job.name }}"
                             id=""
                             [checked]="selectedJobIds.includes(job.name)"
                             (change)="updateSelectedList(job, $event)" />
                    </td>
                    <td style="cursor: pointer" scope="row">
                      {{ job.number }}
                    </td>
                    <td style="cursor: pointer; color: var(--s-primary-color); max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                        title="{{ job.name }}"
                        (click)="toggleJobView(job)">
                      {{ job.name }}
                    </td>
                    <td *ngIf="editedColumnList.includes('Global State')"
                        style="cursor: pointer">
                      {{ job.state }}
                    </td>
                    <td *ngIf="editedColumnList.includes('Stage')"
                        style="cursor: pointer">
                      {{ job.stage }}
                    </td>
                    <td *ngIf="editedColumnList.includes('Status')"
                        style="cursor: pointer; max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                        [title]="
                        job.isSuspended != true
                          ? job.isHeld
                            ? 'Hold'
                            : job.status
                          : 'Suspended'
                      ">
                      {{
                        job.isSuspended != true
                          ? job.isHeld
                            ? "Hold"
                            : job.status
                          : "Suspended"
                      }}
                    </td>
                    <td *ngIf="editedColumnList.includes('Application')">
                      {{ job.application }}
                    </td>
                    <td *ngIf="editedColumnList.includes('Version')">
                      {{ job.version == "" ? "NA" : job.version }}
                    </td>
                    <td *ngIf="editedColumnList.includes('User')"
                        [title]="job.user"
                        style="cursor: pointer; max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      {{ job.user }}
                    </td>
                    <td *ngIf="editedColumnList.includes('#Cores')"
                        style="cursor: pointer">
                      {{ job.maxCores }}
                    </td>
                    <!-- <td
    *ngIf="editedColumnList.includes('BatchNode')"
    style="cursor: pointer"
  >
    {{ job?.nodelist?.split(",")[0] || "NA" }}
  </td> -->
                    <td *ngIf="editedColumnList.includes('BatchNode')"
                        style="cursor: pointer">
                      @if(job?.nodelist != null && job?.nodelist != '' && job?.nodelist != 'Default') {
                      <select style="padding: 2px;">
                        <option *ngFor="let group of getDataOfNodeGroup(job?.nodelist)">{{group}}</option>
                      </select>
                      }@else
                      {
                      <span>Default</span>
                      }
                    </td>
                    <td *ngIf="editedColumnList.includes('Node Group')"
                        style="cursor: pointer; max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                        [title]="job?.partition || 'NA'">
                      {{ job?.partition || "NA" }}
                    </td>
                    <td *ngIf="editedColumnList.includes('UserGroup')"
                        style="cursor: pointer">
                      {{ job?.userGroup || "NA" }}
                    </td>
                    <td *ngIf="editedColumnList.includes('Create Time')"
                        style="cursor: pointer">
                      {{ job.startTime }}
                    </td>
                    <td *ngIf="editedColumnList.includes('End Time')"
                        style="cursor: pointer">
                      {{ job.endTime }}
                    </td>
                    <td *ngIf="editedColumnList.includes('Run Time')"
                          style="cursor: pointer; text-align: right;">
                    <span style="padding-right: 10px; display: inline-block;">{{ job.runTime }}</span>
                                      </td>
                                      <!-- <td
                      *ngIf="editedColumnList.includes('Tag')"
                      style="cursor: pointer; max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                      [title]="job.jobTag"
                    >
                      {{ job.jobTag || "NA" }}
                    </td> -->
                    <td *ngIf="editedColumnList.includes('Tag')"
                        style="cursor: pointer">
                      @if(job?.jobTag != null && job?.jobTag != '' && job?.jobTag != 'NA') {
                      <select style="padding: 2px;">
                        <option *ngFor="let group of getDataOfNodeGroup(job?.jobTag)">{{group}}</option>
                      </select>
                      }@else
                      {
                      <span>NA</span>
                      }
                    </td>
                    <td>
                      <div class="btn-group">
                        <select id="{{ job.number }}"
                                #jobActionDD
                                style="width: 130px"
                                [disabled]="
                                selectedJobIds.length>
                          1 &&
                          selectedJobIds.includes(job.name)
                          "
                          (change)="
                          onOptionsSelected(job.name, job.application,job.version,job.partition, $event)
                          "
                          >
                          @for (action of getJobActionsForThisJob(job); track
                          action.actionValue) {
                          <option [value]="action.actionValue">
                            {{ action.actionName }}
                          </option>
                          }
                        </select>
                      </div>

                      <!-- <ng-select
        [id]="job.number"
        [items]="getJobActionsForThisJob(job)"
        bindLabel="actionName"
        bindValue="actionValue"
        placeholder="Perform Action"
        [fixedPlaceholder]="true"
        (click)="onOptionsSelected(job.name, job.application, $event)">
      </ng-select> -->
                      <!-- <ng-select id="{{ job.number }}" style="width: 130px" >
        @for (action of getJobActionsForThisJob(job); track action.actionValue) {
            <ng-option [value]="action.actionValue" (click)="onOptionsSelected(job.name, job.application, $event)">{{action.actionName}}</ng-option>
        }
    </ng-select> -->
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
            <div class="pagination-container" *ngIf="toShow === true">
              <pagination-controls
                id="job_pagination"
                class="my-pagination"
                style="padding-top: 0.3rem"
                (pageChange)="onPageChange($event)"
                (pageBoundsCorrection)="config.currentPage = $event"
              >
              </pagination-controls>
            </div>
          </div>
        </div>
      </as-split-area>
      <as-split-area
        [size]="jobViewOpen ? advancedViewLength : 0"
        *ngIf="jobViewOpen"
        [minSize]="60"
      >
        <div class="h-100 mx-1 ps-1 pe-1 advanceDetails">
          <app-job-advance-view
            (hideDetails)="hideJobDetails()"
            (maximize)="maximizeView($event)"
            #advanceView
            [CurrentCustomAction]="currentCustomActions"
          ></app-job-advance-view>
        </div>
      </as-split-area>
    </as-split>
  </div>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default"
    zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    name="jobListLoad"
  >
    <p>Please wait ...</p>
  </ngx-spinner>
</div>

<ng-template #popTitle>
  <div class="popover-title">Filters</div>
  <button type="button" class="reset-button" (click)="resetFilter()">
    <i class="bi bi-arrow-counterclockwise"></i>
    <!-- Reset Filters -->
  </button>
</ng-template>
<!-- Popover Content -->
<ng-template #filterContent>
  <div class="filter-container text-grey">
    <!-- From To -->
    <div class="filter-section">
      <label>From {{ startRange }} To</label>
      <div class="field-container">
        <ng-select
          [clearable]="false"
          [searchable]="false"
          [(ngModel)]="entries"
          (ngModelChange)="loadJobDataForRange(entries)"
        >
          <ng-option *ngFor="let entries of jobEntries" [value]="entries">
            {{ entries }}
          </ng-option>
        </ng-select>
      </div>
    </div>

    <!-- User Filter -->
    <div class="filter-section">
      <label>User Filter</label>
      <div class="field-container">
        <ng-select
          [(ngModel)]="filterUser"
          (ngModelChange)="applyFilter()"
          [clearable]="false"
          [searchable]="true"
        >
          <ng-option
            value="All"
            *ngIf="isGlobalAdmin || isReader || allJobsForAllUsers"
            >All Jobs</ng-option
          >
          <ng-option value="{{ currentUser }}">My Jobs</ng-option>
          <ng-option *ngFor="let jobUser of jobUsers" [value]="jobUser">
            {{ jobUser }} Jobs
          </ng-option>
        </ng-select>
      </div>
    </div>

    <!-- Status -->
    <div class="filter-section">
      <label>Job Status</label>
      <div class="field-container">
        <ng-select
          class="text-grey"
          [items]="statuses"
          bindLabel="name"
          bindValue="id"
          [multiple]="true"
          [(ngModel)]="selectedStatuses"
          (ngModelChange)="applyFilter()"
          [closeOnSelect]="false"
          [placeholder]="'All Status'"
          [clearable]="false"
          [searchable]="false"
        >
          <ng-template ng-option-tmp let-item="item" let-item$="item$">
            <input type="checkbox" [checked]="item$.selected" />
            {{ item.name }}
          </ng-template>
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            @if (items.length > 0) {
            <div class="ng-value">
              <span class="ng-value-label">{{ items.length }} selected</span>
            </div>
            }
          </ng-template>
        </ng-select>
      </div>
    </div>
    <!-- <ng-select
          [items]="statuses"
          bindLabel="name"
          bindValue="id"
          [multiple]="true"
          [(ngModel)]="selectedStatuses"
          (ngModelChange)="applyFilter()"
          [closeOnSelect]="false"
          [placeholder]="'All Status'"
          [clearable]="false"
          [searchable]="false">
          <ng-template ng-option-tmp let-item="item" let-item$="item$">
            <input type="checkbox" [checked]="item$.selected" />
            {{ item.name }}
          </ng-template>
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            @if (items.length > 0) {
              <div class="ng-value">
                <span class="ng-value-label">{{ items.length }} selected</span>
              </div>
            }
          </ng-template>
        </ng-select> -->

    <!-- Cores -->
    <div class="filter-section">
      <label>Cores</label>
      <div class="field-container">
        <ng-select
          [(ngModel)]="filterCores"
          (ngModelChange)="applyFilter()"
          [clearable]="false"
          [searchable]="false"
        >
          <ng-option value="All">All Cores</ng-option>
          <ng-option *ngFor="let n of coresList" [value]="n">{{ n }}</ng-option>
        </ng-select>
      </div>
    </div>

    <!-- Application -->
    <div class="filter-section">
      <label>Application</label>
      <div class="field-container">
        <ng-select
          [(ngModel)]="filterApplication"
          (ngModelChange)="applyFilter(); resetAppVersion()"
          [clearable]="false"
          [searchable]="false"
        >
          <ng-option value="All">All Applications</ng-option>
          <!-- <ng-option value="Command">Command</ng-option> -->
          <ng-option *ngFor="let app of UniAppNames" [value]="app">{{
            app
          }}</ng-option>
        </ng-select>
      </div>
    </div>

    <!--Application Version only when selected-->
    <div
      class="filter-section"
      *ngIf="filterApplication !== 'All' && filterApplication !== 'Command'"
    >
      <label>Version</label>
      <div class="field-container">
        <ng-select
          [(ngModel)]="filterVersion"
          (ngModelChange)="applyFilter()"
          [clearable]="false"
          [searchable]="false"
        >
          <ng-option value="All">All Versions</ng-option>
          <ng-option
            *ngFor="let version of availableAppsWithVersions[filterApplication]"
            [value]="version"
            >{{ version }}</ng-option
          >
        </ng-select>
      </div>
    </div>

    <!-- Nodes -->
    <div class="filter-section">
      <label>Nodes</label>
      <div class="field-container">
        <ng-select
          [(ngModel)]="filterNodes"
          (ngModelChange)="applyFilter()"
          [clearable]="false"
          [searchable]="false"
        >
          <ng-option value="All">All Nodes</ng-option>
          <ng-option *ngFor="let n of nodeList" [value]="n">{{ n }}</ng-option>
        </ng-select>
      </div>
    </div>

    <!-- Node Groups -->
    <div class="filter-section">
      <label>Node Groups</label>
      <div class="field-container">
        <ng-select
          [(ngModel)]="filterNodeGroup"
          (ngModelChange)="applyFilter()"
          [clearable]="false"
          [searchable]="false"
        >
          <ng-option value="All">All Node Groups</ng-option>
          <ng-option *ngFor="let n of nodeGroupsList" [value]="n">{{
            n
          }}</ng-option>
        </ng-select>
      </div>
    </div>

    <!-- Date Range -->
    <!-- <div class="filter-section">
      <label>Date Range</label>
      <div class="field-container">
        <input
          [max]="todayDate"
          [owlDateTimeTrigger]="dt8"
          [owlDateTime]="dt8"
          [selectMode]="'range'"
          [formControl]="dateTimePeriod"
          class="form-control"
          placeholder="Choose period"
          readonly>
        <owl-date-time [pickerType]="'calendar'" #dt8></owl-date-time>
      </div>
    </div> -->

    <!-- Reset Button -->
    <div class="d-flex justify-content-end">
      <button type="button" class="reset-button" (click)="resetFilter()">
        <svg
          class="reset-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
          />
        </svg>
        Reset Filters
      </button>
    </div>
  </div>
</ng-template>

<!--Download repo-->

<ng-template #downloadRepo>
  <div class="filter-container">
    <div class="filter-section">
      <label>RepoUrl</label>
      <div class="field-container">
        <input [(ngModel)]="repoUrl" />
      </div>
    </div>

    <div class="filter-section">
      <label>Repo Name</label>
      <div class="field-container">
        <input [(ngModel)]="repoName" />
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <button
      type="button"
      class="reset-button"
      (click)="downloadRepoFromGithub()"
    >
      <span class="bi bi-download"></span>
      Download
    </button>
  </div>
</ng-template>
